module.exports = {
	"agents": {
		"agent123123": {
			"agentname": "New Agent",
			"email": "",
			"phone": ""
		}
	},
	"drivers": {
		"driver636565014024526336": {
			"drivername": "New Driver",
			"email": "",
			"phone": "",
			"service": "",
			"credit": "0",
			"location": "",
			"ratings": 0,
			"vehicleNo": "",
			"driverID": "",
			"profilePhoto": "",
			"UDID": ""
		}
	},
	"orders": {
		"order1520346844604": {
			"clients": "",
			"type": "Web",
			"orderNo": "",
			"orderCreatedDate": "",
			"customerName": "",
			"customerPhoneNo": "",
			"pickupAddress": "",
			"pickupCoordinate": "",
			"dropoffAddress": "",
			"dropoffCoordinate": "",
			"userVehicleBrand": "",
			"userVehicleModel": "",
			"userVehicleNo": "",
			"driver": "",
			"serviceType": "",
			"servicePrice": "",
			"driverPrice": "",
			"orderDriverAcceptedDate": "",
			"orderCompletedDate": "",
			"orderCancelledDate": "",
			"orderRatings": 0,
			"driverCoordinate": "",
			"status": "New",
			"agent": "",
			"notes": ""
		}
	},
	"users": {
		"user636563719612666752": {
			"username": "New User",
			"email": "",
			"phone": "",
			"profilePhoto": "",
			"userID": "",
			"UDID": ""
		}
	},
	"topups": {
		"topup636563719612666752": {
			"driver": "",
			"topupDate": "",
			"amount": "",
			"imageProof": "",
			"method": "",
			"receivedBy": ""
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/schema.json
// module id = 927
// module chunks = 0